import script from "./DevelopmentPlanning.vue?vue&type=script&setup=true&lang=js"
export * from "./DevelopmentPlanning.vue?vue&type=script&setup=true&lang=js"

import "./DevelopmentPlanning.vue?vue&type=style&index=0&id=50af56f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50af56f1"]])

export default __exports__